import { IRegister } from "@mctypes/register.types";
import Axios from "axios";

export const doGetIssueBoardsDepricated = async (projectId: string): Promise<IRegister.BoardPopulated[]> => {
  try {
    const logFetch = await Axios.get(`/api/project/${projectId}/issueboard`);
    return logFetch.data;
  } catch (error) {
    return Promise.reject({ type: "backend", message: error.response?.data });
  }
};
